module.exports = __webpack_public_path__ + "img/fsg_fastpitch.be36e4e1.svg";